import modules from '@/core/collections';
import { createStore } from 'vuex';
import { StoreState } from './models/store.interface';

export default createStore<StoreState>({
   state: {
      fontSize: +(localStorage.getItem('fontSize') || 13),
      isDev: !['acc', 'prod', 'release'].includes(import.meta.env.VITE_APP_ENV),
   },
   getters: {},
   mutations: {},
   actions: {},
   modules,
});
